import { graphql } from "../../../../gql";

const ME_QUERY = graphql(`
  query Me {
    me {
      ...User
    }
  }
`);

export default ME_QUERY;
